import { request } from '@umijs/max';

// 获取品牌列表
export async function getBrandList() {
  return request('/api/all/goodBrand/getList', {
    method: 'POST',
    data: {},
  });
}

// 获取分类树
export async function getCategoryTree() {
  return request('/api/all/goodCategory/getTree', {
    method: 'POST',
    data: {},
  });
}

// 获取商品列表
export async function getGoodPage({
  pageSize,
  current,
  filter,
  sorter,
  with: withParam,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
  with?: string[];
}) {
  return request('/api/shop/good/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
      with: withParam,
    },
  });
}

// 获取商品详情
export async function getGoodInfo(values: API.FormValues) {
  return request('/api/shop/good/info', {
    method: 'POST',
    data: values,
  });
}

// 创建商品
export async function addGood(values: API.FormValues) {
  return request('/api/shop/good/add', {
    method: 'POST',
    data: values,
  });
}

// 编辑商品
export async function editGood(values: API.FormValues) {
  return request('/api/shop/good/edit', {
    method: 'POST',
    data: values,
  });
}

// 删除商品
export async function removeGood(values: API.FormValues) {
  return request('/api/shop/good/remove', {
    method: 'POST',
    data: values,
  });
}

// 导出商品
export async function exportGood(values: API.FormValues) {
  return request('/api/shop/good/export', {
    method: 'POST',
    data: values,
    responseType: 'blob',
  });
}

// 导入商品
export async function importGood(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  return request('/api/shop/good/import', {
    method: 'POST',
    data: formData,
    requestType: 'form',
  });
}
